import { LocalStorageService } from './localstorage.service';

export class TableStateService extends LocalStorageService {
  protected localStorageSuffix = 'temp';
  protected localStorageType = 'table-state';
}
